import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import colors from 'shared-assets/lib/colors';
import InputGroupComponent from './InputGroup';
import CheckboxAsRadioComponent from './CheckboxAsRadio';

const FormStyler = styled.form`
  && {
    ${props => {
      if (props.isInvalid) {
        return `
        *:invalid {
          border: 1px solid ${colors.error};
        }
      `;
      }
      return '';
    }};
  }
`;

export default class Form extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleInvalid = event => {
    this.props.onInvalid(event);
    this.setState({
      isInvalid: true,
    });
  };

  handleSubmit = event => {
    this.props.onSubmit(event);
    this.setState({
      isInvalid: false,
    });
  };

  render() {
    const { children, onInvalid, onSubmit, ...rest } = this.props;
    return (
      <FormStyler
        {...rest}
        onInvalid={this.handleInvalid}
        onSubmit={this.handleSubmit}
        isInvalid={this.state.isInvalid}
      >
        {this.props.children}
      </FormStyler>
    );
  }
}

Form.defaultProps = {
  children: undefined,
  onInvalid: () => {},
  onSubmit: () => {},
};

Form.propTypes = {
  children: PropTypes.node,
  onInvalid: PropTypes.func,
  onSubmit: PropTypes.func,
};

export const CheckboxAsRadio = CheckboxAsRadioComponent;
export const InputGroup = InputGroupComponent;
